module.exports = __webpack_public_path__ + "img/missing_avatar.8ddf134e.svg";